const auth = require("./auth/thunk");

module.exports = {
    ...auth,
  };